import Drawer from '../../components/Drawer';
import GameLeaderboardPage from './GameLeaderboardPage';

export interface GameLeaderboardDrawerProps {
  open: boolean;
  onClose: () => void;
}

export default function GameLeaderboardDrawer({
  open,
  onClose,
}: GameLeaderboardDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose}>
      <GameLeaderboardPage />
    </Drawer>
  );
}
